<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<!-- <app-layout-box></app-layout-box> -->
<!-- <div class="fb-customerchat" page_id="675769885942692">
</div> -->